import { useEffect, useRef, useState } from 'react';

import { UseManualTimerResponseType } from './interfaces';

export const useTimer = (): number => {
  const [time, setTime] = useState(5);
  const interval = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    interval.current = setInterval(() => {
      setTime((prev) => prev - 1);
    }, 1200);

    if (time <= 1) {
      clearInterval(interval.current);
    }

    return () => clearInterval(interval.current);
  }, [time]);

  return time;
};

export const useManualTimer = (): UseManualTimerResponseType => {
  const [timer, setTimer] = useState(35);
  const intervalIdRef = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => clearInterval(intervalIdRef.current), []);

  const startTimer = () => {
    intervalIdRef.current = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
  };

  const stopTimer = () => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
    }
  };

  const clearTimer = () => {
    setTimer(35);
    clearInterval(intervalIdRef.current);
    intervalIdRef.current = undefined;
  };

  return {
    timer,
    intervalId: intervalIdRef.current,
    startTimer,
    clearTimer,
    stopTimer,
  };
};
